var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sdz-modal",
    {
      ref: "sdzModal",
      attrs: {
        title: _vm.modalTitle,
        width: "650",
        "hide-confirm-button": "",
        "hide-cancel-button": "",
        persistent: "",
        "custom-class": "sheet-modal",
        "close-icon": "",
      },
      on: { close: _vm.close },
    },
    [
      [
        _c("div", { staticClass: "sheet-modal-content" }, [
          _c("p", [
            _vm._v(
              "\n        Selecione a planilha padrão correspondente a campanha.\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main", style: _vm.getMainStyle },
            _vm._l(_vm.sheetOptions, function (option, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "list-item",
                  class:
                    _vm.activeClassByCampaign === option.title ? "active" : "",
                  on: {
                    click: function ($event) {
                      return _vm.downloadSheet(option)
                    },
                  },
                },
                [
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: require(`@/assets/images/icons/sheet.svg`),
                        width: "50",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v("Planilha padrão - " + _vm._s(option.title)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: require(`@/assets/images/icons/downloadSheet.svg`),
                      width: "20",
                    },
                  }),
                ]
              )
            }),
            0
          ),
        ]),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }